import ReceptionPeriodical from './ReceptionPeriodical.jsx';
import DanhSachYeuCau from './DanhSachYeuCau.jsx';
export {
  ReceptionPeriodical,
  DanhSachYeuCau
};



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/list-reception-periodical/index.js